export const USER_CHANNEL_ACCESS_REMOVE_MESSAGE: string =
  "Are you sure you want to remove users access to channel";
